import React from 'react';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'customers',
  namespace: 'customer',
  mountedUrl: '/daily-rental/customers',
  title: 'Customers',
  columns: [
    { attribute: 'name' },
    { attribute: 'entity.primary_email', label: 'email' },
  ],
  useQuickSearch: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/customer/containers/Listing.jsx